<template>
    <div class="content">
        <froala-view :value="content" @click="$emit('click')" />
    </div>
</template>

<script>
export default {
    name: 'DisplayContent',

    props: {
        content: {
            type: String,
            required: true,
        },
    },

    emits: ['click'],

    created() {
        // getSignedCookies('uploaded-images');
    },
};
</script>

<style lang="scss">
@import 'resources/scss/vendor/froala/custom_classes.scss';

.embeddedObject {
    max-width: 99% !important;
}

.fr_view {
    color: var(--text-color)
}
</style>
